import styled from "styled-components";

export const CompanyLogo = styled.img<{ $logoHeight: number }>`
    display: block;
    margin: 0 auto;
    height: ${({ $logoHeight }) => `${$logoHeight}px`};
    width: auto;
`;
